import { isIndexableRoute } from './routeManifest';

export const isNoIndexRoute = (pathname: string) => !isIndexableRoute(pathname);
